/**
 *
 * Search mock service func
 * Logic to handle search within UI
 * By Prashant Bhatt <pbhatt@svb.com> (www.svb.com)
 *
 */

const searchMockService = async (payload, store) => {
  const { filter_by, conditions, pagination } = payload;
  const { apisDataFromJson, faqsDataFromJson, solutionsDataFromJson, resourcessDataFromJson } =
    store;
  let [
    apisFiltered,
    apisResult,
    faqsFiltered,
    faqsResult,
    solutionsFiltered,
    solutionsResult,
    resourcesFiltered,
    resourcesResult,
  ] = Array.from({ length: 8 }, () => []); //initialize empty arrays
  //returns filtered data with options provided
  const filterData = (data, filterOptions) => {
    return data.filter((item) =>
      filterOptions.every(({ property, operator, values }) => {
        //returns true if every condtion matches for each item, false will specify no match
        if (operator.toLowerCase() === 'contains') {
          //if operator is contains do filter activity
          if (property === '*') {
            // if property is *, search in all the keys of each item except key with id and non string values, return true on matching the condition
            return Object.entries(item).some(([key, val]) =>
              values.some(
                (value) =>
                  typeof val === 'string' &&
                  key !== 'id' &&
                  val.toLowerCase().includes(value.toLowerCase()),
              ),
            );
          } else if (Array.isArray(property)) {
            //search in multiple keys, returns true on matching the condition
            return property.some((key) =>
              values.some(
                (value) =>
                  typeof item[key] === 'string' &&
                  item[key].toLowerCase().includes(value.toLowerCase()),
              ),
            );
          } else {
            //search in single key, returns true on matching the condition
            return values.some(
              (value) =>
                typeof item[property] === 'string' &&
                item[property].toLowerCase().includes(value.toLowerCase()),
            );
          }
        }
        return true; //default is true to not to do filter activity on items if no operator or operator without contains
      }),
    );
  };
  //provides pagination on filtered data depending on limit and offset, default is 100 records, offset 1
  const paginateData = (data, limit, offset) => {
    const totalItems = data.length;
    const paginatedItems = data.slice(offset - 1, offset - 1 + limit);
    return { items: paginatedItems, total_items: totalItems };
  };
  //handles search activity against data from each sections(apis,faqs,solutions, resources) on tags selection, default is search in all the contents
  const SearchWithinContainer = (tagSelected) => {
    switch (tagSelected.toLowerCase()) {
      case 'apis':
        apisFiltered = filterData(apisDataFromJson, conditions);
        apisResult = paginateData(apisFiltered, pagination.limit || 100, pagination.offset || 1);
        break;
      case 'faqs':
        faqsFiltered = filterData(faqsDataFromJson, conditions);
        faqsResult = paginateData(faqsFiltered, pagination.limit || 100, pagination.offset || 1);
        break;
      case 'solutions':
        solutionsFiltered = filterData(solutionsDataFromJson, conditions);
        resourcesFiltered = filterData(resourcessDataFromJson, conditions);
        solutionsResult = paginateData(
          solutionsFiltered,
          pagination.limit || 100,
          pagination.offset || 1,
        );
        resourcesResult = paginateData(
          resourcesFiltered,
          pagination.limit || 100,
          pagination.offset || 1,
        );
        break;
      case 'all':
        apisFiltered = filterData(apisDataFromJson, conditions);
        apisResult = paginateData(apisFiltered, pagination.limit || 100, pagination.offset || 1);
        faqsFiltered = filterData(faqsDataFromJson, conditions);
        faqsResult = paginateData(faqsFiltered, pagination.limit || 100, pagination.offset || 1);
        solutionsFiltered = filterData(solutionsDataFromJson, conditions);
        solutionsResult = paginateData(
          solutionsFiltered,
          pagination.limit || 100,
          pagination.offset || 1,
        );
        resourcesFiltered = filterData(resourcessDataFromJson, conditions);
        resourcesResult = paginateData(
          resourcesFiltered,
          pagination.limit || 100,
          pagination.offset || 1,
        );
        break;
      default:
        break;
    }
  };
  //filter by selected tags or *
  if (Array.isArray(filter_by)) {
    //for multiple selected filter tags
    filter_by.forEach((tagSelected) => {
      SearchWithinContainer(tagSelected);
    });
  } else {
    //for single selection
    SearchWithinContainer(filter_by);
  }
  //json object returned to search parent component
  return {
    apis: apisResult,
    faqs: faqsResult,
    solutions: solutionsResult,
    resources: resourcesResult,
  };
};

export default searchMockService;
